import { Divider } from '@mui/material';
import { ReactNode } from 'react';
import DeformationDisplayControls from '~/components/dvf/DeformationDisplayControls';
import DeformationStatistics from '~/components/dvf/DeformationStatistics';
import { DvfField } from '~/domain/dvf/dvfField';

export default function DeformationFieldPanel({
    field,
    children,
}: {
    field: DvfField;
    children?: ReactNode;
}) {
    return (
        <>
            <DeformationDisplayControls field={field} />
            {children}
            <Divider data-testid="dvf-statistics-divider" />
            <DeformationStatistics field={field} />
        </>
    );
}
